import { createUseStyles } from 'react-jss'

import { lightGrey } from '../../styles/const/colors'
import { defaultBorderRadius, transitionShort, zIndex8 } from '../../styles/const/common'

const useStyles = createUseStyles({
  triggerElement: {
    display: 'flex',
    cursor: ({ isDisabled }) => !isDisabled && 'pointer'
  },
  arrowIndicator: {
    width: 12,
    height: 'auto',
    marginLeft: 15,
    transition: transitionShort,
    transform: ({ opened }) => (opened ? 'rotate(180deg)' : 'rotate(0deg)')
  },
  dropdownBody: {
    border: {
      width: 2,
      style: 'solid',
      color: lightGrey,
      radius: defaultBorderRadius
    },
    backgroundColor: 'white',
    cursor: 'auto',
    animation: '$showDropdown 200ms ease',
    // zIndex9 is used to cover the dropdown by header on mob
    zIndex: zIndex8
  },
  '@keyframes showDropdown': {
    '0%': {
      display: 'none',
      opacity: 0
    },
    '1%': {
      display: 'block',
      opacity: 0
    },
    '100%': {
      display: 'block',
      opacity: 1
    }
  }
})

export default useStyles
